const LAST_INCREMENT_KEY =  `dvWebFeedbackLastIncrement`
const COUNTER_KEY = `dvWebFeedbackTriggerCounter`
const HAS_ANSWERED_KEY = (questionId: string) => `dvWebFeedbackHasAnsweredQuestion${questionId}`
const IGNORE_ALREADY_ANSWERED = (questionId: string) => `test_dvWebFeedbackIgnoreAnsweredQuestion${questionId}`


// We need to parseInt as localStorage only supports 
// strings, but W3C reccomends that broswers allow any
// type. Hence this function accepts "any".

const setLocalStorage = (key: string, value: any) => (
    window.localStorage &&
    window.localStorage.setItem(key, value)
)

const getLocalStorageInt = (key: string): number => (
    window.localStorage &&
    window.localStorage.getItem(key) &&
    parseInt(window.localStorage.getItem(key)) || 0
)

const getLocalStorageBool = (key: string): boolean => (
    window.localStorage &&
    window.localStorage.getItem(key) &&
    (window.localStorage.getItem(key) === 'true')
)

export const counterEligibility = (hoursBetweenIncrement: number) => {
    const millsBetweenTimout = hoursBetweenIncrement * 1000 * 60 * 60
    const now = new Date().getTime()
    const counter = getLocalStorageInt(COUNTER_KEY)
    if ((now - getLocalStorageInt(LAST_INCREMENT_KEY) > millsBetweenTimout)) {
        setLocalStorage(LAST_INCREMENT_KEY, now)
        setLocalStorage(COUNTER_KEY, counter + 1)
    }
    if (counter && counter > 0 && counter % 5 === 0) {
        return true
    }
    return false
}

export const resetCounter = () => {
    setLocalStorage(COUNTER_KEY, 0)
}

export const hasAnswered = (questionId: string): boolean =>
    getLocalStorageBool(HAS_ANSWERED_KEY(questionId))

export const ignoreAlreadyAnswered = (questionId: string): boolean =>
    getLocalStorageBool(IGNORE_ALREADY_ANSWERED(questionId))

export const setAnswered = (questionId: string) => {
    setLocalStorage(HAS_ANSWERED_KEY(questionId), 'true')
}